import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d18c01b6")

_pushScopeId("data-v-d18c01b6")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = { class: "header-name" }
const _hoisted_4 = { class: "header-name" }
const _hoisted_5 = { class: "header-name" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "text item" }
const _hoisted_8 = { style: {"color":"red"} }
const _hoisted_9 = { style: {"color":"red"} }
const _hoisted_10 = { class: "text item" }
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = { style: {"color":"red"} }
const _hoisted_13 = { class: "text item" }
const _hoisted_14 = { style: {"color":"red"} }
const _hoisted_15 = { style: {"color":"red"} }
const _hoisted_16 = { class: "text item" }
const _hoisted_17 = { style: {"color":"red"} }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  class: "filert-container",
  style: {"margin-top":"10px"}
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "dialog-footer" }
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = { class: "dialog-footer" }
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = { class: "adminTransfer" }
const _hoisted_26 = { style: {"width":"485px","border-right":"1px solid rgb(229, 229, 229)"} }
const _hoisted_27 = { style: {"width":"100%","background":"#fff"} }
const _hoisted_28 = { class: "zhpy" }
const _hoisted_29 = { style: {"width":"100%","background":"#fff"} }
const _hoisted_30 = { class: "zhpy" }
const _hoisted_31 = { class: "wb-140" }
const _hoisted_32 = { class: "wb-140 mg-10" }
const _hoisted_33 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_transfer = _resolveComponent("el-transfer")
  const _directive_waves = _resolveDirective("waves")
  const _directive_permission = _resolveDirective("permission")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.t("search.adminId")) + "：", 1),
      _createVNode(_component_el_input, {
        style: {"width":"220px"},
        modelValue: _ctx.listQuery.uid,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listQuery.uid = $event)),
        placeholder: _ctx.$t('input.enterAdminID'),
        clearable: ""
      }, null, 8, ["modelValue", "placeholder"]),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("search.account")) + "：", 1),
      _createVNode(_component_el_input, {
        style: {"width":"200px"},
        modelValue: _ctx.listQuery.loginName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listQuery.loginName = $event)),
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("search.remark")) + "：", 1),
      _createVNode(_component_el_input, {
        style: {"width":"200px"},
        modelValue: _ctx.listQuery.remarks,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listQuery.remarks = $event)),
        clearable: ""
      }, null, 8, ["modelValue"]),
      _withDirectives(_createVNode(_component_el_button, {
        style: {"margin-left":"10px"},
        class: "filter-item",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toSearch())),
        icon: "el-icon-search"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        icon: "el-icon-refresh-left",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toReload()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        icon: "el-icon-plus",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toAdd()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ])
    ]),
    _createVNode(_component_el_card, {
      class: "box-card",
      style: {"margin":"10px 0"}
    }, {
      header: _withId(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode("span", null, _toDisplayString(_ctx.t("statistics.statistics")), 1)
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t("statistics.threeyearsvirtualcurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.virtualTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.threeusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.threetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t("statistics.PromotionalAccountRenewalCoin")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.PreferensurplusCount) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.PreferenusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.PreferentotalCount), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t("statistics.Industrycurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.tradeTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.tradeusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.tradetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("statistics.Oneyearvirtualcurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.virtualOneTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.virtualOneTotalUsed) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.virtualOneTotalCount), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.t("statistics.Oneyearrenewalcurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.virtualOneRenewTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.virtualOneusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.virtualOnetotalCount) + "               ", 1),
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.virtualRenewTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.virtualRenewusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.virtualRenewtotalCount), 1)
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.t("statistics.VIPrenewalcurrency")) + "：", 1),
          _createTextVNode(_toDisplayString(_ctx.t("statistics.available")) + "：" + _toDisplayString(_ctx.vipTotal) + "，" + _toDisplayString(_ctx.t("statistics.used")) + "：" + _toDisplayString(_ctx.vipusedCount) + "，" + _toDisplayString(_ctx.t("statistics.total")) + "：" + _toDisplayString(_ctx.viptotalCount), 1)
        ])
      ]),
      _: 1
    }),
    _hoisted_18,
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.list,
      key: _ctx.tableKey,
      border: "",
      "highlight-current-row": "",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.ID')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.uid), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Account')
        }, {
          default: _withId(({row}) => [
            _createVNode("div", {
              class: "accountLoginName",
              onClick: ($event: any) => (_ctx.nextLoginName(row.loginName, row.id))
            }, _toDisplayString(row.loginName), 9, ["onClick"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.password')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.password), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Creator')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.createBy), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.IP')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.loginIp), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Total')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.totalCount), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Used')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.usedCount), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Unused')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.surplusCount), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.Remark')
        }, {
          default: _withId(({row}) => [
            _createTextVNode(_toDisplayString(row.remarks), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('table.actions'),
          width: "480",
          "class-name": "buttonSize"
        }, {
          default: _withId((scope) => [
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleFreeze(scope.$index, scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.unfreeze")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_vShow, scope.row.loginFlag == 4]
            ]),
            (_ctx.getloginName == scope.row.createBy)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.getloginName == scope.row.createBy)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "small",
                  onClick: ($event: any) => (_ctx.handleIssued(scope.row))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.Issue Credit")) + "1111 ", 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.getloginName == scope.row.createBy)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  size: "small",
                  onClick: ($event: any) => (_ctx.handleRecycle(scope.row))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.Recover Credit")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleyearSetting(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.Set Years")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['一级管理']]
            ]),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handlepeemission(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.Set Permissions")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['一级管理']]
            ]),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": _ctx.t('table.confirm'),
              "cancel-button-text": _ctx.t('table.cancel'),
              "icon-color": "red",
              title: _ctx.t('table.Are you sure to recycle'),
              onConfirm: ($event: any) => (_ctx.hanleDelete(scope.row))
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, { size: "small" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("table.Recover")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["confirm-button-text", "cancel-button-text", "title", "onConfirm"]),
            _withDirectives(_createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handletransferSetting(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("table.Migrate users")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_permission, ['一级管理']]
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _withDirectives(_createVNode(_component_el_pagination, {
      total: _ctx.total,
      currentPage: _ctx.listQuery.page.pageNo,
      "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_ctx.listQuery.page.pageNo = $event)),
      limit: _ctx.listQuery.page.pageSize,
      "onUpdate:limit": _cache[8] || (_cache[8] = ($event: any) => (_ctx.listQuery.page.pageSize = $event)),
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "page-sizes": [10, 20, 50, 100],
      layout: "total, sizes, prev, pager, next, jumper"
    }, null, 8, ["total", "currentPage", "limit", "onSizeChange", "onCurrentChange"]), [
      [_vShow, _ctx.total > 0]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      title: _ctx.title
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_21, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeForm()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submit()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          "label-width": "140px",
          rules: _ctx.rules,
          model: _ctx.ruleForm
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: _ctx.getloginName }, {
              default: _withId(() => [
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode("1111" + _toDisplayString(_ctx.t("statistics.Oneyearvirtualcurrency")) + ":" + _toDisplayString(_ctx.virtualOneTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.virtualTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Oneyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.virtualOneRenewTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.VIPrenewalcurrency")) + ":" + _toDisplayString(_ctx.vipTotal), 1)
                  ]),
                  _: 1
                }),
                _hoisted_19,
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.virtualRenewTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Industrycurrency")) + ":" + _toDisplayString(_ctx.tradeTotal), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { label: _ctx.loginName }, {
              default: _withId(() => [
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Oneyearvirtualcurrency")) + ":" + _toDisplayString(_ctx.targetVirtualOneTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.targetVirtualTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Industrycurrency")) + ":" + _toDisplayString(_ctx.targetTradeTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.VIPrenewalcurrency")) + _toDisplayString(_ctx.vipxunibi), 1)
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.PromotionalAccountRenewalCoin")) + ":" + _toDisplayString(_ctx.targetRenewSurlpusCount), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_directive_permission, ['一级管理']]
                ]),
                _hoisted_20,
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Oneyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.targetVirtualOneRenewTotal), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, null, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("statistics.Threeyearrenewalcurrency")) + ":" + _toDisplayString(_ctx.targetVirtualRenewTotal), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('statistics.Currency type')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.ruleForm.type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.ruleForm.type = $event))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('statistics.Number'),
              prop: "count"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.count,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.ruleForm.count = $event)),
                  modelModifiers: { number: true },
                  style: {"width":"205px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('statistics.Remark')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.remark,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.ruleForm.remark = $event)),
                  modelModifiers: { number: true },
                  style: {"width":"205px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormdistribute,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogFormdistribute = $event)),
      title: _ctx.t('form.Assignfunctiongroups')
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogFormdistribute = false))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submitDisForm()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formdistribute",
          "label-width": "140px",
          model: _ctx.distributeForm
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.discountmonth')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.distributeForm.months,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.distributeForm.months = $event)),
                  modelModifiers: { number: true },
                  style: {"width":"205px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.functiongroup'),
              prop: "fgids"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.distributeForm.fgids,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.distributeForm.fgids = $event)),
                  multiple: "",
                  placeholder: _ctx.t('input.Please select function group')
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogyearsdistribute,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.dialogyearsdistribute = $event)),
      title: _ctx.t('table.Set Years')
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submityearForm()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "yeardistribute",
          rules: _ctx.yearRules,
          "label-width": "165px",
          model: _ctx.yearbuteForm
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.account limited time'),
              prop: "years"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.yearbuteForm.years,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.yearbuteForm.years = $event)),
                  placeholder: _ctx.t('input.Please select the number of years')
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yearsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createVNode("div", null, _toDisplayString(_ctx.t("input.Note")), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      title: _ctx.t('table.Set Permissions'),
      modelValue: _ctx.dialogPermissonbute,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.dialogPermissonbute = $event)),
      ref: "permissionRef"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submitPermissionForm()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.rulePermissionForm,
          "label-width": "140px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.Set Permissions')
            }, {
              default: _withId(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.rulePermissionForm.permissionIds,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.rulePermissionForm.permissionIds = $event)),
                  size: "small"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.permissionsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.id,
                        label: item.id
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "transferuser",
      modelValue: _ctx.dialogtarbsfetdistribute,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.dialogtarbsfetdistribute = $event)),
      title: _ctx.t('table.Migrate users'),
      width: "60%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_33, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.submitTransferForm()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.closetransfer()))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "transferdistribute",
          rules: _ctx.transferRules,
          "label-width": "140px",
          model: _ctx.transferForm
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('table.Migration administrator')
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.rowName), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('table.Migrate group'),
                  prop: "fromId"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.transferForm.fromId,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.transferForm.fromId = $event)),
                      placeholder: 
                  _ctx.t('input.Please select the group of the migrated user')
                ,
                      onChange: _ctx.toggleTransfer,
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      "remote-method": _ctx.remoteMethod
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transferFormList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.gid,
                            label: item.name,
                            value: item.gid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onChange", "remote-method"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", null, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('table.Target administrator'),
                  prop: "targetId"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.transferForm.targetId,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.transferForm.targetId = $event)),
                      placeholder: _ctx.t('input.Please select the target administrator'),
                      onChange: _ctx.toggeleLevelTraget,
                      filterable: "",
                      remote: "",
                      "reserve-keyword": ""
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lowestlevelList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.loginName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('table.Target group'),
                  prop: "gid"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.transferForm.gid,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.transferForm.gid = $event)),
                      placeholder: _ctx.t('input.Please select default group'),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      "remote-method": _ctx.remotetargetMethod
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.targetGroupList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.gid,
                            label: item.name,
                            value: item.gid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "remote-method"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('table.Members'),
              prop: "uids"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_transfer, {
                  modelValue: _ctx.transferForm.uids,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.transferForm.uids = $event)),
                  data: _ctx.transferFormdataList.data,
                  titles: [_ctx.t('table.Items'), _ctx.t('table.Selected')]
                }, {
                  "left-footer": _withId(() => [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t("table.Account")), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.t("table.designation")), 1)
                    ]),
                    _createVNode(_component_el_input, {
                      style: {"width":"100%"},
                      placeholder: _ctx.t('input.Please enter a name to search'),
                      "prefix-icon": _ctx.Search,
                      onInput: _ctx.filterMethod,
                      modelValue: _ctx.leftSearchValue,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.leftSearchValue = $event))
                    }, null, 8, ["placeholder", "prefix-icon", "onInput", "modelValue"])
                  ]),
                  "right-footer": _withId(() => [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("span", _hoisted_30, _toDisplayString(_ctx.t("table.Account")), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.t("table.designation")), 1)
                    ]),
                    _createVNode(_component_el_input, {
                      style: {"width":"100%"},
                      placeholder: _ctx.t('input.Please enter a name to search'),
                      "prefix-icon": _ctx.Search,
                      onChange: _ctx.filterMethod,
                      modelValue: _ctx.rightSearchValue,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.rightSearchValue = $event))
                    }, null, 8, ["placeholder", "prefix-icon", "onChange", "modelValue"])
                  ]),
                  default: _withId(({option}) => [
                    _createVNode("span", _hoisted_31, _toDisplayString(option.name), 1),
                    _createVNode("span", _hoisted_32, _toDisplayString(option.label), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "data", "titles"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
})